import { Box } from "@mui/material";

import CheckboxColumn from "components/Table/CheckboxColumn";
import StatusTag from "components/StatusTag";

import EllipsisTooltipCell from "../EllipsisTooltipCell";

import { DEVICE_TYPE, DEVICE_STATUS_TAG, STATUS_TAG_LABEL } from "const";
import { SEVERITY_LEVEL, EVENTS_LOG_EVENTS_TYPE, EVENTS_LOG, EVENTS_LOG_MAP } from "const/eventsLog";

import { getEventMessageText } from "../helper"

import { formatTimestampByToday } from "utils/format";
import getEventsLogMessage from "utils/getEventsLogMessage";

const routerColumns = (columnHelper, permissions, setDrawerOpen, setDrawerData) =>
  [
    permissions &&
    (permissions === "Admin" || permissions === "Super Admin") &&
    CheckboxColumn(columnHelper, null, {
      disableByColumnData: [
        { key: "acknowledge", value: true },
      ],
    }),
    columnHelper.accessor(
      row => SEVERITY_LEVEL[row.severity],
      {
        id: "severity",
        header: "Severity",
        cell: (info) => (
          <StatusTag
            status={info.getValue()}
            statusMapping={DEVICE_STATUS_TAG}
            labelMapping={STATUS_TAG_LABEL}
          />
        ),
      }
    ),
    columnHelper.accessor("createdAt", {
      header: "Time",
      cell: (info) => <Box>{formatTimestampByToday(info.getValue()) ?? "-"}</Box>,
      meta: {
        exportValue: ({ row }) => formatTimestampByToday(row.original.createdAt, 'export')
      }
    }),
    columnHelper.accessor(row => row.siteName ?? "-",
      {
        id: "siteName",
        header: "Site",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    columnHelper.accessor(row => row.eventType ?? "-",
      {
        id: "eventType",
        header: "Event Type",
        cell: info => <Box>{EVENTS_LOG_EVENTS_TYPE[info.getValue()]}</Box>,
        meta: {
          exportValue: ({ row }) => EVENTS_LOG_EVENTS_TYPE[row.original.eventType]
        }
      }
    ),
    columnHelper.accessor(row => DEVICE_TYPE[row.deviceType] ?? "-",
      {
        id: "deviceType",
        header: "Device Type",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    columnHelper.accessor("deviceName", {
      header: "Device Name",
      cell: (info) => <Box>{info.getValue() ?? "-"}</Box>,
    }),
    columnHelper.accessor("deviceMacAddress", {
      header: "Mac Address",
      cell: (info) => <Box>{info.getValue() ?? "-"}</Box>,
    }),
    columnHelper.accessor(
      (row) => getEventsLogMessage(row, EVENTS_LOG, EVENTS_LOG_MAP),
      {
        id: "description",
        header: "Description",
        cell: (info) => <EllipsisTooltipCell
          text={info.getValue()}
          rowData={info.row.original}
          setDrawerOpen={setDrawerOpen}
          setDrawerData={setDrawerData}
        />,
        meta: {
          exportValue: ({ row }) => getEventMessageText(row.original, EVENTS_LOG, EVENTS_LOG_MAP)
        }
      }
    ),
    columnHelper.accessor(
      row => row.payload.username ?? "-",
      {
        id: "clientName",
        header: "Client Name",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
    columnHelper.accessor(
      row => row.payload.macAddress ?? "-",
      {
        id: "clientMacAddress",
        header: "Client MAC Address",
        cell: info => <Box>{info.getValue()}</Box>,
      }
    ),
  ].filter(Boolean);

export default routerColumns;
